import { Link } from "react-router-dom";
import VerdictBadge from "@/components/feature/VerdictBadge";
import { formatHeat } from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function FeaturedSection() {
  const sorted = [...articles].sort((a, b) => b.heat - a.heat);
  const main = sorted[0];
  const side = sorted.slice(1, 4);

  return (
    <section className="w-full">
      <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-700 text-foreground-950 md:text-3xl">本周焦点</h2>
          <p className="mt-2 text-sm text-foreground-600">热度最高的鉴定条目，附完整时间线与后续回应。</p>
        </div>
        <span className="inline-flex items-center gap-1.5 text-sm text-accent-700">
          <i className="ri-fire-line text-lg"></i>
          按站内热度排序
        </span>
      </div>

      <div className="grid gap-6 lg:grid-cols-5">
        <Link
          to={`/article/${main.id}`}
          className="group relative col-span-1 flex min-h-[320px] flex-col justify-end overflow-hidden rounded-lg border border-background-200 lg:col-span-3"
        >
          <img
            src={main.cover}
            alt={main.coverAlt}
            className="absolute inset-0 h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.03]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/55 to-foreground-950/10"></div>
          <div className="relative p-5 md:p-7">
            <div className="mb-3 flex flex-wrap items-center gap-2">
              <VerdictBadge verdict={main.verdict} size="md" />
              <span className="rounded-full bg-background-50/15 px-3 py-1 text-xs text-background-100">{main.category}</span>
            </div>
            <h3 className="font-heading text-xl font-700 leading-snug text-background-50 md:text-2xl">{main.title}</h3>
            <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-background-200">{main.summary}</p>
          </div>
        </Link>

        <div className="col-span-1 flex flex-col gap-4 lg:col-span-2">
          {side.map((a, idx) => (
            <Link
              key={a.id}
              to={`/article/${a.id}`}
              className="group flex flex-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span className="font-label text-2xl font-600 text-primary-400/70">{String(idx + 1).padStart(2, "0")}</span>
              <div className="flex min-w-0 flex-1 flex-col">
                <VerdictBadge verdict={a.verdict} />
                <h3 className="mt-2 line-clamp-2 font-heading text-sm font-600 leading-snug text-foreground-950 transition-colors group-hover:text-accent-700 md:text-base">
                  {a.title}
                </h3>
                <div className="mt-auto flex items-center gap-3 pt-2 text-xs text-foreground-500">
                  <span>{a.category}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    {formatHeat(a.heat)}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}